<template>
  <LevelExplorer />
</template>

<script setup lang="ts">
import LevelExplorer from '@/views/components/level-explorer.vue';
</script>
